import {
  Typography, Box, Grid, Select, MenuItem,
  TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button,
  Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, TextField,
  FormControlLabel
} from "@mui/material";
import React, { useState, useEffect } from "react";
import style from "./style";
import countryList from "react-select-country-list";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/Modal";

const ControlCentrePage = ({ handleCountrySelection, taxLabel, handleAddTaxLabel, countryData, handleAddCreditType, updateCreditType }) => {
  const options = countryList().getData();
  const navigate = useNavigate();
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [tempSelected, setTempSelected] = useState([]);
  const [dialogOpenFor, setDialogOpenFor] = useState(null);
  const [newButtonLabel, setNewButtonLabel] = useState("");
  const [includeBenificiary, setIncludeBenificiary] = useState(false);
  const [editCredit, setEditCredit] = useState(null);
  const [creditsOpen, setCreditsOpen] = useState(false);
  const [from, setFrom] = useState(null);
  const [credit, setCredit] = useState("");

  useEffect(() => {
    if (countryData?.length) {
      setSelectedCountries(countryData);
      setTempSelected(countryData);
    }
  }, [countryData]);

  const handleSaveChanges = () => {
    setSelectedCountries(tempSelected);
    handleCountrySelection(tempSelected);
  };

  const handleNavigateTaxTable = (taxCountry) => {
    navigate("/dashboard/TaxTable", { state: { taxCountry } });
  };

  const handleNavigateThreshold = (taxCountry) => {
    navigate("/dashboard/Threshold", { state: { taxCountry } });
  };

  const handleNavigateUniversalTax = (country, label) => {
    navigate("/dashboard/UniversalTax", { state: { country, label } })
  }

  const handleNavigateSubscriptionSettings = (country) => {
    navigate("/dashboard/planManagement", { state: { country, readOnly: true } });
  };

  const handleNavigateTopupManagement = (country) => {
    navigate("/dashboard/topupManagement", { state: { country } });
  };

  const handleNavigateFinancialYear = (country) => {
    navigate("/dashboard/FinancialYear", { state: { taxCountry: country, country } });
  };

  const handleAddCustomButton = () => {
    if (!dialogOpenFor || !newButtonLabel.trim()) return;
    handleAddTaxLabel(newButtonLabel, dialogOpenFor)
    setNewButtonLabel("");
    setDialogOpenFor(null);
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2, mt: 3, ml: 3, mr: 2 }}>
        <Typography sx={style.gridText}>Control Centre</Typography>
      </Box>
      <Grid container sx={style.mainContainer}>
        <Grid item xs={12} lg={12} sx={style.gridbox}>
          <Box sx={style.modalGrid}>
            <Box sx={style.inputBoxs}>
              <Typography sx={style.inputTexts}>Country</Typography>
              <Select
                multiple
                value={tempSelected}
                onChange={(event) => setTempSelected(event.target.value)}
                name="country"
                sx={style.countryInput}
                displayEmpty
                renderValue={() => "Select Country"}
              >
                {options.map((country, index) => (
                  <MenuItem
                    key={index}
                    value={country.label}
                    sx={{
                      backgroundColor: tempSelected.includes(country.label) ? "lightblue" : "transparent",
                      fontWeight: tempSelected.includes(country.label) ? "bold" : "normal"
                    }}
                  >
                    <Checkbox
                      checked={tempSelected.includes(country.label)}
                      sx={{ marginRight: 1 }}
                    />
                    {country.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveChanges}
              sx={style.jobButton}
            >
              Save Changes
            </Button>
          </Box>

          <TableContainer sx={style.noShadow}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={style.tableHead}>Country</TableCell>
                  <TableCell sx={{ paddingLeft: 25 }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedCountries.map((country, index) => (
                  <TableRow key={index}>
                    <TableCell>{country}</TableCell>
                    <TableCell sx={{ paddingLeft: { xs: 1, md: 3 } }}>
                      <Box sx={style.actionContainer}>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={style.actionButton}
                          onClick={() => handleNavigateSubscriptionSettings(country)}
                        >
                          Subscriptions
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={style.actionButton}
                          onClick={() => handleNavigateTopupManagement(country)}
                        >
                          Topup Management
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={style.actionButton}
                          onClick={() => handleNavigateFinancialYear(country)}
                        >
                          Financial Year
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={style.actionButton}
                          onClick={() => handleNavigateTaxTable(country)}
                        >
                          Tax Table
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={style.actionButton}
                          onClick={() => handleNavigateThreshold(country)}
                        >
                          Threshold
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={style.actionButton}
                          onClick={() => navigate("/dashboard/Rebate", { state: { taxCountry: country } })}
                        >
                          Rebate
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={style.actionButton}
                          onClick={() => navigate("/dashboard/Credits", { state: { taxCountry: country } })}
                        >
                          Credits
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={style.actionButton}
                          onClick={() => navigate("/dashboard/Allowance", { state: { taxCountry: country } })}
                        >
                          Allowances
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={style.actionButton}
                          onClick={() => navigate("/dashboard/Leave", { state: { taxCountry: country } })}
                        >
                          Leaves
                        </Button>
                        {(taxLabel || [])
                          .filter((label) => label.country === country)
                          .map((label, idx) => (
                            <Button
                              key={`${label.country}-${idx}`}
                              variant="contained"
                              color="primary"
                              sx={style.actionButton}
                              onClick={() => handleNavigateUniversalTax(country, label)}
                            >
                              {label?.title}
                            </Button>
                          ))}
                        <Button
                          variant="outlined"
                          color="info"
                          sx={style.addTaxButton}
                          onClick={() => setDialogOpenFor(country)}
                        >
                          +
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Dialog open={Boolean(dialogOpenFor)} onClose={() => setDialogOpenFor(null)}>
        <DialogTitle>Add Tax</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            value={newButtonLabel}
            onChange={(e) => setNewButtonLabel(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpenFor(null)}>Cancel</Button>
          <Button variant="contained" onClick={handleAddCustomButton}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={creditsOpen}
        setOpen={setCreditsOpen}
        btnText={from === "edit" ? "Save Changes" : "Add New"}
        title={"Credits Type"}
        handleCheck={() => {
          from === "edit"
            ? updateCreditType(credit, editCredit, includeBenificiary)
            : handleAddCreditType(credit, includeBenificiary);
          setCreditsOpen(false);
          setCredit("");
          setIncludeBenificiary(false);
          setFrom("new");
          setEditCredit(null);
        }}
      >
        <Box>
          <Typography>
            {from === "edit" ? "Edit Credit Type" : "Add Credit Type"}
          </Typography>
          <TextField
            sx={style.modalInput}
            name="Credits"
            value={credit || ""}
            onChange={(e) => {
              setCredit(e.target.value);
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={includeBenificiary || false}
                onChange={(e) => setIncludeBenificiary(e.target.checked)}
              />
            }
            label="Includes Beneficiary"
          />
        </Box>
      </Modal>
    </>
  );
};

export default ControlCentrePage;
